import styled, { css } from "styled-components";
import { ClaimMessageType } from "./ClaimMessageType";

export const ClaimMessages = styled.div<{ type?: ClaimMessageType }>`
  display: flex;
  align-items: center;
  margin: 4px 0px;
  width: 100%;
  max-width: 1600px;
  padding: 6px;
  font-weight: 400;
  border-radius: 6px;

  ${({ type = 'error' }) => {
    switch (type) {
      case 'advice':
      case 'info':
        return css`background-color: #fff4ce; color: black;`;
      case 'success':
        return css`background-color: #dff6dd; color: black;`;
      case 'warning':
        return css`background-color: #fff4ce; color: black;`;
      case 'error':
      default:
        return css`background-color: #fde7e9; color: black;`;
    }
  }}
`;
